import ENERGISWAP_DEFAULT_LIST from '@energi/energiswap-default-token-list'

import { TOKEN_BLACKLIST, TICKERS_PROTECTED } from '../constants'

const TOKEN_WHITELIST = {}

ENERGISWAP_DEFAULT_LIST.tokens.forEach(token => TOKEN_WHITELIST[token.address.toLowerCase()] = true)

const isBlackListed = (ticker, address) => {
  if (!ticker || !address) {
    return true
  }

  const addressLower = address.toLowerCase()

  if (TOKEN_WHITELIST[addressLower]) {
    // always accept whitelisted addresses,
    // unless they are blacklisted
    return !!TOKEN_BLACKLIST[addressLower]
  }

  return !!TOKEN_BLACKLIST[addressLower] || !!TICKERS_PROTECTED[ticker]
}

export default isBlackListed
